import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'
import throttle from 'lodash/throttle'

import type {ActionCreator, AppDispatch, AppThunk} from '../actions/types'

const defaultThrottleTime = 100 //ms

type AggregationTypeArray<V> = ReadonlyArray<V>
export class ActionThrottlerWithArrayCollect {
  action: AppThunk<void>
  throttledAction: AppThunk<void>
  aggregation: AggregationTypeArray<any> = []
  constructor(
    action: ActionCreator<AggregationTypeArray<any>>,
    defaultAggregation: AggregationTypeArray<any>,
    throttleTime?: number,
  ) {
    this.action = (dispatch: AppDispatch) => {
      dispatch(action(this.aggregation))
      this.aggregation = []
    }

    this.throttledAction = throttle(this.action, throttleTime ?? defaultThrottleTime)
    this.aggregation = defaultAggregation
  }

  fetch(data: AggregationTypeArray<any>, force?: boolean): AppThunk<void> {
    this.aggregation = [...this.aggregation, ...data]
    return force === true ? this.action : this.throttledAction
  }
}
export class ActionThrottlerWithObjectCollect<V> {
  action: (dispatch: AppDispatch) => unknown
  throttledAction: (dispatch: AppDispatch) => unknown
  aggregation: KeyValue<string | number, V> = {}
  constructor(
    action: ActionCreator<KeyValue<string | number, V>>,
    defaultAggregation: KeyValue<string | number, V>,
    throttleTime?: number,
    throttleOptions?: {leading?: boolean | undefined; trailing?: boolean | undefined},
  ) {
    this.action = (dispatch: AppDispatch) => {
      dispatch(action(this.aggregation))
      this.aggregation = {}
    }

    this.throttledAction = throttle(
      this.action,
      throttleTime ?? defaultThrottleTime,
      throttleOptions,
    )
    this.aggregation = defaultAggregation
  }

  fetch(data: KeyValue<string | number, V>, force?: boolean): AppThunk<any> {
    this.aggregation = {...this.aggregation, ...data}
    return force === true ? this.action : this.throttledAction
  }

  cancel(key: string | number) {
    const {[key]: canceled, ...rest} = this.aggregation
    this.aggregation = rest
  }
}
